import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4567572&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=a4567572&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4567572",
  null
  
)

export default component.exports